import React from "react";

export default function CommonAreaForm({
    state,
    handleUpdate,
    showPreviewImageCommon,
    onSubmit,
    submitText,
    editar
}) {

    const seleccionados = Array.isArray(state.subfraccionamientosSeleccionados)
        ? state.subfraccionamientosSeleccionados.map((id) => id.toString())
        : state.subfraccionamientosSeleccionados
            ? [state.subfraccionamientosSeleccionados.toString()]
            : [];

    const subs = state.subfraccionamientos || [];

    return (
        <div className="flex flex-col w-full items-center">
            <form className="w-full space-y-1.5 text-xs" id="commonAreaForm" onSubmit={onSubmit}>

                {/* Bloque datos básicos */}
                <div className="border rounded-md p-1.5 shadow-sm">
                    <h3 className="font-extrabold mb-1 text-lg underline text-purple-950">Datos básicos</h3>
                    <div className="grid grid-cols-2 gap-1.5">
                        {/* Nombre */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">Nombre:</label>
                            <input
                                type="text"
                                className="input-edit-sm text-left"
                                value={state.nombre}
                                onChange={(e) => handleUpdate({ nombre: e.target.value })}
                            />
                        </div>

                        {/* Subfraccionamiento */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">{state.subLabel}:</label>
                            <div className="flex flex-col border rounded p-2 max-h-40 overflow-y-auto">
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={
                                            subs.length > 0 &&
                                            seleccionados.length === subs.length
                                        }
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            if (checked) {
                                                const allIds = subs.map((s) =>
                                                    s.id_subfraccionamiento.toString()
                                                );
                                                handleUpdate({ subfraccionamientosSeleccionados: allIds });
                                            } else {
                                                handleUpdate({ subfraccionamientosSeleccionados: [] });
                                            }
                                        }}
                                    />
                                    <span>TODOS</span>
                                </label>
                                {subs.map((sub) => (
                                    <label
                                        key={sub.id_subfraccionamiento}
                                        className="flex items-center space-x-2"
                                    >
                                        <input
                                            type="checkbox"
                                            value={sub.id_subfraccionamiento}
                                            checked={seleccionados.includes(
                                                sub.id_subfraccionamiento.toString()
                                            )}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const already = seleccionados.includes(value);
                                                const newSelection = already
                                                    ? seleccionados.filter((id) => id !== value)
                                                    : [...seleccionados, value];
                                                handleUpdate({ subfraccionamientosSeleccionados: newSelection });
                                            }}
                                        />
                                        <span>{sub.nombre}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Categoría */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">Categoría:</label>
                            <select
                                value={state.categoria}
                                onChange={(e) => handleUpdate({ categoria: e.target.value })}
                                className="input-edit-sm text-left"
                            >
                                {state.categories.map((cat) => (
                                    <option key={cat.id_categoria} value={cat.id_categoria}>
                                        {cat.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Depósito */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">Depósito:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm text-left"
                                value={state.fianza}
                                onChange={(e) => handleUpdate({ fianza: e.target.value })}
                            />
                        </div>

                        {/* Imagen */}
                        {editar && (<div className="flex flex-col items-center col-span-2">
                            <div className="relative flex justify-center">
                                <img
                                    src={state.imagenArea || require("../../img/empty_image.png")}
                                    alt="Preview área común"
                                    className="w-48 h-28 object-cover rounded shadow mx-auto"
                                />
                                <label className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white cursor-pointer opacity-0 hover:opacity-100 transition text-xs">
                                    <i className="fas fa-file-upload mb-1"></i>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={showPreviewImageCommon}
                                        className="hidden"
                                    />
                                    <span>Subir imagen</span>
                                </label>
                            </div>
                        </div>)}
                    </div>
                </div>

                {/* Bloque reservas */}
                <div className="border rounded-md p-1.5 shadow-sm">
                    <h3 className="font-extrabold mb-1 text-lg underline text-purple-950">Configuración de reservas</h3>
                    <div className="grid grid-cols-2 gap-1.5">
                        {/* Días previos */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">Días previos:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm text-left"
                                value={state.diasPrevios}
                                onChange={(e) => handleUpdate({ diasPrevios: e.target.value })}
                            />
                        </div>
                        {/* Minutos previos */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">Minutos previos:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm text-left"
                                value={state.minutosPrevios}
                                onChange={(e) => handleUpdate({ minutosPrevios: e.target.value })}
                            />
                        </div>
                        {/* Disponibilidad */}
                        <div className="flex flex-col col-span-2">
                            <label className="font-semibold mb-0.5 text-xs">Disponibilidad:</label>
                            <div className="flex space-x-4">
                                <label className="flex items-center space-x-1.5">
                                    <input
                                        type="radio"
                                        checked={state.isDiasDisponible}
                                        onChange={() => handleUpdate({ isDiasDisponible: true })}
                                    />
                                    <span>Días disponibles</span>
                                </label>
                                <label className="flex items-center space-x-1.5">
                                    <input
                                        type="radio"
                                        checked={!state.isDiasDisponible}
                                        onChange={() => handleUpdate({ isDiasDisponible: false })}
                                    />
                                    <span>Horas disponibles</span>
                                </label>
                            </div>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm text-left mt-0.5"
                                value={state.tiempoDisponible}
                                onChange={(e) => handleUpdate({ tiempoDisponible: e.target.value })}
                            />
                        </div>
                        {/* Límites */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">Reservas anuales:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm text-left"
                                value={state.anuales}
                                onChange={(e) => handleUpdate({ anuales: e.target.value })}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">Reservas mensuales:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm text-left"
                                value={state.mensuales}
                                onChange={(e) => handleUpdate({ mensuales: e.target.value })}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">Reservas diarias:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm text-left"
                                value={state.diarias}
                                onChange={(e) => handleUpdate({ diarias: e.target.value })}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-semibold mb-0.5 text-xs">Reservas abiertas:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm text-left"
                                value={state.consecutivas}
                                onChange={(e) => handleUpdate({ consecutivas: e.target.value })}
                            />
                        </div>
                    </div>
                </div>

                {/* Bloque aforo máximo */}
                <div className="border rounded-md p-1.5 shadow-sm space-y-1.5">
                    <h3 className="font-extrabold text-lg underline text-purple-950">Aforo máximo</h3>

                    <div className="flex items-center">
                        <input
                            type="checkbox"
                            id="aforoMax"
                            checked={state.aforoMax}
                            onChange={(e) => handleUpdate({ aforoMax: e.target.checked })}
                            className="peer h-4 w-4 accent-purple-600 shrink-0"
                        />
                        <label
                            htmlFor="aforoMax"
                            className="ml-1.5 font-semibold text-xs whitespace-nowrap peer-checked:text-purple-600"
                        >
                            Aforo máximo
                        </label>
                    </div>

                    {state.aforoMax && (
                        <div className="grid grid-cols-2 gap-1.5 mt-1.5">
                            <div className="flex flex-col">
                                <label htmlFor="aforo" className="font-semibold mb-0.5 text-xs whitespace-nowrap">Aforo máximo:</label>
                                <p className="text-[10px] text-gray-500 mb-0.5 leading-tight">
                                    Cantidad máxima de personas que pueden estar en un mismo horario
                                </p>
                                <input
                                    id="aforo"
                                    type="number"
                                    min="1"
                                    onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                    className="input-edit-select-sm text-left"
                                    value={state.aforo}
                                    onChange={(e) => handleUpdate({ aforo: parseInt(e.target.value) })}
                                />
                            </div>

                            <div className="flex flex-col">
                                <label htmlFor="maXVivienda" className="font-semibold mb-0.5 text-xs whitespace-nowrap">Máximo por vivienda:</label>
                                <p className="text-[10px] text-gray-500 mb-0.5 leading-tight">
                                    Cantidad máxima de personas que una vivienda puede reservar en un mismo horario
                                </p>
                                <input
                                    id="maXVivienda"
                                    type="number"
                                    min="1"
                                    onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                    className="input-edit-select-sm text-left"
                                    value={state.maXVivienda}
                                    onChange={(e) => handleUpdate({ maXVivienda: parseInt(e.target.value) })}
                                />
                            </div>
                        </div>
                    )}
                </div>

                {/* Bloque gestión */}
                <div className="border rounded-md p-1.5 shadow-sm space-y-1.5">
                    <h3 className="font-extrabold text-lg underline text-purple-950">Gestión del área común</h3>

                    <div className="grid grid-cols-2 gap-1.5">
                        <div className="flex flex-col gap-1">
                            <div className="flex items-center">
                                <input
                                    id="pausar"
                                    type="checkbox"
                                    checked={state.pausar}
                                    onChange={(e) => handleUpdate({ pausar: e.target.checked })}
                                    className="peer h-4 w-4 accent-blue-600 shrink-0"
                                />
                                <label htmlFor="pausar" className="ml-1.5 font-semibold text-xs whitespace-nowrap peer-checked:text-blue-600">
                                    Pausar reservas
                                </label>
                            </div>
                            {state.pausar && (
                                <textarea
                                    name="motivo"
                                    rows="2"
                                    className="w-full input-edit-sm text-left"
                                    value={state.motivo}
                                    onChange={(e) => handleUpdate({ motivo: e.target.value })}
                                />
                            )}
                        </div>

                        <div className="flex items-center">
                            <input
                                id="activo"
                                type="checkbox"
                                checked={state.activo}
                                onChange={(e) => handleUpdate({ activo: e.target.checked })}
                                className="peer h-4 w-4 accent-green-600 shrink-0"
                            />
                            <label htmlFor="activo" className="ml-1.5 font-semibold text-xs whitespace-nowrap peer-checked:text-green-600">
                                Activar área común
                            </label>
                        </div>
                    </div>
                </div>

            </form>
        </div>
    );
}
